/** A minimal rename modal (Slice 8) — title + prefilled name input + Save. Mirrors CrmViewSaveModal's
 * backdrop/card pattern. Save is gated on a non-empty, actually-changed name. */
import { useState } from 'react';
import styles from './crm.module.css';

interface Props {
  title: string;
  initialName: string;
  onSave: (name: string) => void;
  onClose: () => void;
  saving?: boolean;
  /** surfaced INSIDE the modal — a page-flow banner would render behind the backdrop (adv-review). */
  error?: string | null;
}

export function CrmRenameModal({ title, initialName, onSave, onClose, saving, error }: Props) {
  const [name, setName] = useState(initialName);
  const trimmed = name.trim();
  const canSave = !!trimmed && trimmed !== initialName && !saving;
  const submit = () => { if (canSave) onSave(trimmed); };
  return (
    <div className={styles.modalBackdrop} onMouseDown={onClose}>
      <div className={styles.modalCard} role="dialog" aria-label={title} onMouseDown={(e) => e.stopPropagation()}>
        <h3 className={styles.modalTitle}>{title}</h3>
        <input
          className={styles.modalInput}
          autoFocus
          maxLength={200}
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); if (e.key === 'Escape') onClose(); }}
        />
        {error && <div className={styles.modalError} role="alert">{error}</div>}
        <div className={styles.modalActions}>
          <button className={styles.gridMiniBtn} onClick={onClose}>Cancel</button>
          <button className={styles.gridPageBtn} disabled={!canSave} onClick={submit}>Save</button>
        </div>
      </div>
    </div>
  );
}
